'use strict';

define('vb/helpers/navigate',[
  'vb/private/stateManagement/router',
], (Router) => {
  /**
   * A set of routines related to navigation and used by built-in actions.
   * @category Helper
   */
  class Navigate {
    /**
     * Navigate to an external site with given a set of input parameters.
     *
     * @param {Object} options - Navigation options
     * @param {String} options.url - The url to navigate to (required)
     * @param {Object<String, String>} [options.params] - A map of URL parameters (optional)
     * @param {String} [options.hash] - The hash entry (optional)
     * @param {String} [options.history] - Effect on the browser history. Allowed value are 'replace' or 'push'.
     * If the value is 'replace', the current browser history entry is replaced,
     * meaning that back button will not go back to it.
     * (optional and default is push)
     * @public
     */
    static toUrl(options) {
      Router.navigateToExternal(options);
    }

    /**
     * Calculates the URL of a page or flow based on its ID path.
     *
     * @param {String} path - The ID path of the page or flow (e.g., "/pageId/flowId/pageId").
     * @param {String} [routerStrategy="default"] - The routing strategy to use ("path" or "query").
     * Defaults to the application's default router strategy if not provided.
     * @returns {String} The calculated URL of the page or flow.
     * @suppress
     */
    static getUrlFromPath(path, routerStrategy) {
      return Router.getUrlFromPath(path, routerStrategy);
    }

    /**
     * This function is to be used for making webdriver test possible for "Do you want to leave" dialog.
     * It clears the existing busy context and return a function to restore the busyContext. This
     * function should be called on dialog.open() and the return function should be called on dialog.close()
     * @suppress
     */
    static clearBusyContextBeforeDialog() {
      return Router.clearBusyContextBeforeDialog();
    }
  }

  return Navigate;
});

